export const AVAILABLE_FORMATS = [
  'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'pdf',
];

export const AVAILABLE_IMGS = [
  'jpeg', 'png', 'gif', 'bmp', 'jpg',
];
